import { render, staticRenderFns } from "./GLGroups.vue?vue&type=template&id=3b2995f6&scoped=true"
import script from "./GLGroups.vue?vue&type=script&lang=js"
export * from "./GLGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2995f6",
  null
  
)

export default component.exports